import { Link } from "react-router-dom";
import logoImage from "@/assets/logo.png";

interface BrandLogoProps {
  size?: "small" | "medium" | "large";
  variant?: "default" | "compact";
}

export function BrandLogo({
  size = "medium",
  variant = "default",
}: BrandLogoProps) {
  const logoSizes = {
    small: "h-6 w-6 min-w-6",
    medium: "h-7 w-7 min-w-7",
    large: "h-9 w-9 min-w-9",
  };

  const textSizes = {
    small: "text-[13px]",
    medium: "text-sm",
    large: "text-base",
  };

  const suffixSizes = {
    small: "text-[10px]",
    medium: "text-[11px]",
    large: "text-xs",
  };

  return (
    <Link
      to="/"
      className="flex items-center gap-2 min-w-0 shrink"
      aria-label="Vote.GameOn home"
    >
      <img
        src={logoImage}
        alt=""
        className={`${logoSizes[size]} shrink-0`}
      />
      {variant !== "compact" && (
        <>
          {/* Desktop: single line */}
          <span className="hidden md:flex items-baseline gap-0.5 min-w-0 truncate whitespace-nowrap leading-none">
            <span className={`${textSizes[size]} font-semibold tracking-tight`}>
              Vote.GameOn
            </span>
            <span
              className={`${suffixSizes[size]} font-medium text-muted-foreground`}
            >
              .futbol
            </span>
          </span>

          {/* Mobile: stacked 3-line */}
          <span className="flex md:hidden flex-col leading-none">
            <span className={`${textSizes[size]} font-semibold tracking-tight`}>
              Vote
            </span>
            <span className={`${textSizes[size]} font-semibold tracking-tight -mt-0.5`}>
              .GameOn
            </span>
            <span className={`${suffixSizes[size]} font-medium text-muted-foreground -mt-0.5`}>
              .futbol
            </span>
          </span>
        </>
      )}
    </Link>
  );
}
